import { t } from 'i18next';
import React from 'react';
import { Col, Row } from 'reactstrap';
import './track-page.scss';

function CustomerInfo({ data }) {
  return (
    <>
      <p className='main_info'>
        {' '}
        {t('customer')} {t('waybill_entry.information')}
      </p>
      <div className='main_info_container'>
        <Row>
          <Col md={6} style={{ textAlign: 'center', marginBottom: 10 }}>
            <h4>
              {t('waybill_entry.shipper')} {t('waybill_entry.information')}
            </h4>
          </Col>
          <Col md={6} style={{ textAlign: 'center', marginBottom: 10 }}>
            <h4>
              {t('waybill_entry.receiver')} {t('waybill_entry.information')}
            </h4>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.shipper')}</p>
              </Col>
              <Col>
                <p>{data?.sender?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.receiver')}: </p>
              </Col>
              <Col>
                <p>{data?.receiver?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.phone')}: </p>
              </Col>
              <Col>
                <p>{data?.sender?.phone}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.phone')}: </p>
              </Col>
              <Col>
                <p>{data?.receiver?.phone}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.company')}: </p>
              </Col>
              <Col>
                <p>{data?.sender?.company}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.company')}: </p>
              </Col>
              <Col>
                <p>{data?.receiver?.company}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.address')}: </p>
              </Col>
              <Col>
                <p>{data?.sender?.address}</p>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col className='main_info_title'>
                <p>{t('waybill_entry.address')}: </p>
              </Col>
              <Col>
                <p>{data?.receiver?.address}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CustomerInfo;
